var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Python",
    clipPath: "url(#clip0_170_3487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.52 0.390625C24.1949 0.390627 25.7764 11.3731 25.7764 11.3731L25.8046 22.7509H49.9718V26.167H16.2055C16.2055 26.167 0 24.3292 0 49.8824C-1.80625e-06 75.4357 14.1446 74.5295 14.1446 74.5295H22.5861V62.6718C22.5861 62.6718 22.1311 48.5273 36.5048 48.5273H60.4743C60.4743 48.5273 73.9413 48.745 73.9413 35.512V13.6317C73.9413 13.6317 75.9859 0.390625 49.52 0.390625ZM36.1942 8.04167C38.5987 8.04167 40.5421 9.98504 40.5421 12.3895C40.5421 14.7939 38.5987 16.7373 36.1942 16.7373C33.7898 16.7373 31.8464 14.7939 31.8464 12.3895C31.8464 9.98504 33.7898 8.04167 36.1942 8.04167Z",
    fill: "url(#paint0_linear_170_3487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.2391 99.6302C75.5642 99.6302 73.9827 88.6477 73.9827 88.6477L73.9545 77.2699H49.7874V73.8538H83.5536C83.5536 73.8538 99.7591 75.6916 99.7591 50.1384C99.7592 24.5851 85.6146 25.4913 85.6146 25.4913H77.173V37.349C77.173 37.349 77.6281 51.4935 63.2543 51.4935H39.2848C39.2848 51.4935 25.8179 51.2758 25.8179 64.5088V86.3891C25.8179 86.3891 23.7732 99.6302 50.2391 99.6302ZM63.5649 91.9791C61.1605 91.9791 59.2171 90.0358 59.2171 87.6313C59.2171 85.2269 61.1605 83.2835 63.5649 83.2835C65.9694 83.2835 67.9127 85.2269 67.9127 87.6313C67.9128 90.0358 65.9694 91.9791 63.5649 91.9791Z",
    fill: "url(#paint1_linear_170_3487)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_3487",
    x1: 9.58706,
    y1: 9.31698,
    x2: 59.0242,
    y2: 58.2609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_3487",
    x1: 39.9314,
    y1: 40.7453,
    x2: 93.0216,
    y2: 90.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_3487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.812aae6f3ab844d844dcb44ac305fa5e.svg";
export { ForwardRef as ReactComponent };